import { render, staticRenderFns } from "./PanelSimulatorMarketItemRequireByLevel.vue?vue&type=template&id=6a6c5ac2&scoped=true&"
import script from "./PanelSimulatorMarketItemRequireByLevel.vue?vue&type=script&lang=js&"
export * from "./PanelSimulatorMarketItemRequireByLevel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c5ac2",
  null
  
)

export default component.exports